<template>
  <div
    class="mt-4 flex flex-col gap-3 border-t border-slate-200 px-5 py-3 dark:border-slate-600"
    data-test="totals"
  >
    <div>
      <div class="truncate leading-tight text-gray-500 capitalize-first">
        {{ $t('global.total_to_pay') }}
      </div>
      <AmountFormatter
        class="text-2xl leading-tight font-bold"
        :class="
          amountClass(commissionNote.total_tvac) ||
          'text-gray-900 dark:text-gray-100'
        "
        :amount="commissionNote.total_tvac"
      />
    </div>
    <div>
      <div
        class="truncate text-xs leading-tight font-medium text-gray-500 capitalize-first"
      >
        {{ $t('attributes.total_htva') }}
      </div>
      <AmountFormatter
        class="leading-tight font-medium"
        :class="
          amountClass(commissionNote.total_htva) ||
          'text-gray-900 dark:text-gray-100'
        "
        :amount="commissionNote.total_htva"
      />
    </div>
    <div v-for="group in vatGroups" :key="group.vat_rate">
      <div
        class="truncate text-xs leading-tight font-medium text-gray-500 capitalize-first"
      >
        {{ $t('global.tva') }} {{ group.vat_rate }} %
      </div>
      <AmountFormatter
        class="leading-tight font-medium"
        :class="amountClass(group.tva) || 'text-gray-900 dark:text-gray-100'"
        :amount="group.tva"
      />
    </div>
  </div>
</template>

<script>
import AmountFormatter from '@c/AmountFormatter.vue'
import {
  amountClass,
  roundCent,
  vatOf
} from '@/views/invoicing/show/commissionNote/components/commissionNoteItem'

/**
 * The totals of a note, by VAT rate, as the left panel of the note shows them.
 * The API only gives the total of the VAT, so the VAT of each rate is made as
 * the API makes it: the VAT of each line rounded to the cent, then added up.
 */
export default {
  name: 'CommissionNoteTotals',
  components: { AmountFormatter },
  props: {
    commissionNote: { type: Object, required: true }
  },
  computed: {
    vatGroups() {
      const groups = {}
      for (const item of this.commissionNote.items ?? []) {
        if (item.counts_in_total === false) continue
        const group = (groups[item.vat_rate] ??= {
          vat_rate: item.vat_rate,
          tva: 0
        })
        group.tva += vatOf(item.commission_htva, item.vat_rate)
      }
      return Object.values(groups).map((group) => ({
        vat_rate: group.vat_rate,
        tva: roundCent(group.tva)
      }))
    }
  },
  methods: { amountClass }
}
</script>
